import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import { GrMultiSelectFilterDialogComponent } from '../gr-multi-select-filter-dialog/gr-multi-select-filter-dialog.component';
import { FilterLabSampleService } from '../filter-lab-sample.service';
import { Route, Router } from '@angular/router';

@Component({
  selector: 'app-date-range-select-dialog',
  templateUrl: './date-range-select-dialog.component.html',
  styleUrls: ['./date-range-select-dialog.component.css']
})
export class DateRangeSelectDialogComponent implements OnInit {
  customDate=false
  range:FormGroup
  lastCustomDate:any
  routeEnds:any

  constructor(
    public dialogRef: MatDialogRef<DateRangeSelectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GrMultiSelectFilterDialogComponent,
    private labSampleService: FilterLabSampleService,
    private router: Router
  ) { 
    const route = router.url.split("/")
    this.routeEnds = route[route.length-1]
  }

  ngOnInit(): void {
    this.range = new FormGroup({
      startDate: new FormControl(),
      endDate: new FormControl(),
    });
    if(this.routeEnds=="labSample"){
      if(this.labSampleService.customDate){
        this.customDate = true
        if( this.labSampleService.filtered_customDate$){
          this.lastCustomDate = this.labSampleService.filtered_customDate$
          this.range.patchValue({
            startDate: this.labSampleService.filtered_customDate$['startDate'],
            endDate: this.labSampleService.filtered_customDate$['endDate']
          })
        }
      }
    }
  }

  onAreaListControlChanged(list,selected) {
    if(selected.item.identifier=="custom"){
      this.customDate=true
    
      if(this.routeEnds=="labSample"){
        if( this.labSampleService.filtered_customDate$){
          this.lastCustomDate = this.labSampleService.filtered_customDate$
          this.range.patchValue({
            startDate: this.labSampleService.filtered_customDate$['startDate'],
            endDate: this.labSampleService.filtered_customDate$['endDate']
          })
          this.setCustomDate(list)
        }
      }

    }else{
      this.customDate=false
      if(this.routeEnds=='labSample')
        this.labSampleService.setFilteredCustomDate()
      this.data.ref.setActiveFilter(list.selectedOptions.selected.map(el => el.value))
    }
  }


  setCustomDate(list){
    if(this.range.value.startDate && this.range.value.endDate){
      const startDate = new Date(this.range.value.startDate)
      const endDate = new Date(this.range.value.endDate)
      const filterValue = {startDate: startDate, endDate: endDate}

      this.data.ref.options.forEach(option=> {
        if(option.item.identifier == "custom"){
          option.item['filterValue'] = filterValue
        }
      })
      this.data.ref.setActiveFilter(list.selectedOptions.selected.map(el => el.value))
    }
  }

}
